const infoChangeSuccessStepDealWithJoin = {
    title: 'Внимание!',
    description:
        'В данной сделке создано приглашение. При переносе сделки из этапа «Успешно» приглашение <b>будет удалено</b>. Хотите перенести сделку?',
    buttonText: 'Перенести',
} as const;

export default infoChangeSuccessStepDealWithJoin;
